import { useLang } from "../i18n/LanguageContext";

const LABELS = { pl: "PL", en: "EN", it: "IT", de: "DE" };
const CODES = ["pl", "en", "it", "de"];

export default function LanguageSwitcher({ variant = "header" }) {
  const { lang, setLang } = useLang();

  if (variant === "mobile") {
    return (
      <div className="grid grid-cols-4 gap-2" data-testid="lang-switcher-mobile">
        {CODES.map((l) => (
          <button
            key={l}
            data-testid={`lang-btn-mobile-${l}`}
            onClick={() => setLang(l)}
            className={`h-11 border uppercase-track text-xs transition ${
              lang === l
                ? "bg-gold text-charcoal border-gold"
                : "border-cream/30 text-cream hover:border-gold hover:text-gold"
            }`}
          >
            {LABELS[l]}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div
      className="hidden md:inline-flex items-center border border-cream/25 bg-charcoal/30 backdrop-blur-sm"
      data-testid="lang-switcher"
    >
      {CODES.map((l, i) => (
        <button
          key={l}
          data-testid={`lang-btn-${l}`}
          onClick={() => setLang(l)}
          className={`h-9 px-3 uppercase-track text-[11px] font-medium cursor-pointer transition-all duration-200 hover:scale-[1.06] hover:text-gold ${
            lang === l ? "text-gold" : "text-cream"
          } ${i > 0 ? "border-l border-cream/15" : ""}`}
        >
          {LABELS[l]}
        </button>
      ))}
    </div>
  );
}
